import {
  FETCH_OHLC_SUCCESS,
  FETCH_OHLC_FAIL,
} from '../actions/types';

const initialState = {
  ohlc: {},
  errors: [],
};

const ohlc = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OHLC_SUCCESS:
      return {
        ...state,
        ohlc: action.payload,
        loading: false,
      };
    case FETCH_OHLC_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default ohlc;
